"use client";

import { useEffect } from "react";

/* The signature molten-bronze cursor (the one on the Digital front door), site-wide.
 * Loads a 5 KB script after the page is idle, only for mouse/trackpad users; phones and touch
 * screens never download it. Reduced-motion users get the calm version. */
export function BronzeCursor() {
  useEffect(() => {
    if (!window.matchMedia("(pointer:fine)").matches) return;
    if (document.getElementById("bronze-cursor-js")) return;
    const load = () => {
      const s = document.createElement("script");
      s.id = "bronze-cursor-js";
      s.src = "/foundry/store-cursor.js";
      s.async = true;
      document.body.appendChild(s);
    };
    const w = window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number };
    if (w.requestIdleCallback) w.requestIdleCallback(load, { timeout: 2500 });
    else setTimeout(load, 1200);
  }, []);
  return null;
}
